import { VerticalOption } from '@amzn/aet-galactus-kit';

export const convertToVerticalOption = (
  verticalValue?: string
): VerticalOption => {
  if (verticalValue === 'Amazon Business') {
    return VerticalOption['AB'];
  } else if (verticalValue === 'Amazon Business V2') {
    return VerticalOption['AB_V2'];
  } else if (verticalValue === 'Amazon Business GO V2') {
    return VerticalOption['AB_GO_V2'];
  } else if (verticalValue === 'D2AS') {
    return VerticalOption['D2'];
  }
  return VerticalOption[verticalValue as keyof typeof VerticalOption];
};

export const decideVerticalOption = (
  verticalValue: string | undefined | null,
  isGoUser: boolean,
  enableRAPRemovalAndCCXUpdate: boolean
): VerticalOption => {
  if (!verticalValue) {
    if (enableRAPRemovalAndCCXUpdate) {
      return isGoUser ? VerticalOption.Total_GO_V2 : VerticalOption.Total_V2;
    }
    return VerticalOption.Total;
  }
  const verticalKey =
    verticalValue === 'Amazon Business'
      ? 'AB'
      : verticalValue === 'D2AS'
        ? 'D2'
        : verticalValue;
  const goSuffix = enableRAPRemovalAndCCXUpdate && isGoUser ? '_GO' : '';
  const v2Suffix = enableRAPRemovalAndCCXUpdate ? '_V2' : '';
  return VerticalOption[
    (verticalKey + goSuffix + v2Suffix) as keyof typeof VerticalOption
  ];
};

export const CONSUMER_VERTICALS = new Set([
  VerticalOption.Consumer,
  VerticalOption.Consumer_V2,
  VerticalOption.Consumer_GO_V2,
]);
export const D2_VERTICALS = new Set([
  VerticalOption.D2,
  VerticalOption.D2_V2,
  VerticalOption.D2_GO_V2,
]);
export const SDS_VERTICALS = new Set([
  VerticalOption.SDS,
  VerticalOption.SDS_V2,
  VerticalOption.SDS_GO_V2,
]);
export const CAP_VERTICALS = new Set([
  VerticalOption.CAP,
  VerticalOption.CAP_V2,
  VerticalOption.CAP_GO_V2,
]);
export const AB_VERTICALS = new Set([
  VerticalOption.AB,
  VerticalOption.AB_V2,
  VerticalOption.AB_GO_V2,
]);
export const TOTAL_VERTICALS = new Set([
  VerticalOption.Total,
  VerticalOption.Total_V2,
  VerticalOption.Total_GO_V2,
]);

// https://quip-amazon.com/f4A0ARLcCpG4/CCX-Details-BRD-TMSW#temp:C:fMY9607128275a8448bb498af1fa

export const canCsaAccessRealtimeHmd = new Map<VerticalOption, boolean>([
  [VerticalOption.Total, false],
  [VerticalOption.Total_V2, false],
  [VerticalOption.Total_QCS, false],
  [VerticalOption.Total_CSC, false],
  [VerticalOption.Total_GO_V2, true],
  [VerticalOption.AB, true],
  [VerticalOption.AB_V2, true],
  [VerticalOption.AB_GO_V2, true],
  [VerticalOption.CAP, false],
  [VerticalOption.CAP_V2, false],
  [VerticalOption.CAP_GO_V2, true],
  [VerticalOption.D2, false],
  [VerticalOption.D2_V2, false],
  [VerticalOption.D2_GO_V2, true],
  [VerticalOption.SDS, true],
  [VerticalOption.SDS_GO_V2, true],
  [VerticalOption.SDS_V2, true],
  [VerticalOption.Consumer, false],
  [VerticalOption.Consumer_V2, false],
  [VerticalOption.Consumer_QCS, false],
  [VerticalOption.Consumer_GO_V2, true],
]);

// Helper function to check if verticals are restricted
export const checkAccessToRealTimeHmdByOrgVertical = (
  orgVertical: string | null
): boolean => {
  if (!orgVertical) return true;

  const verticalOption = convertToVerticalOption(orgVertical);

  if (
    verticalOption === VerticalOption.Consumer ||
    verticalOption === VerticalOption.CAP
  ) {
    return false;
  }

  return true;
};

export const checkAccessToRealTimeHmd = (
  isGoUser: boolean,
  isProfileTm: boolean,
  LHChosenVertical: VerticalOption,
  orgVertical: string | null,
  isExclusivelyOm: boolean,
  isOmViewingOwnProfile: boolean
): boolean => {
  if (isGoUser) {
    return true;
  }

  if (isExclusivelyOm && isOmViewingOwnProfile) {
    return false;
  }

  if (isProfileTm) {
    // For TM users, only check org vertical
    return checkAccessToRealTimeHmdByOrgVertical(orgVertical);
  }

  // For CSA users, check the map
  return canCsaAccessRealtimeHmd.get(LHChosenVertical) ?? false;
};
